import { createI18n, type VueMessageType } from 'vue-i18n';

type NamespaceMessages = Record<string, VueMessageType>;
type JsonModule = { default: NamespaceMessages };

const appLocales = import.meta.glob<JsonModule>('@/locales/**/*.json', { eager: true });

function loadLocaleMessages() {
  const messages: Record<string, Record<string, NamespaceMessages>> = {};

  for (const [path, localeModule] of Object.entries(appLocales)) {
    const match = path.match(/\/locales\/([a-zA-Z-]+)\/([a-zA-Z-]+)\.json$/);
    if (!match) {
      console.warn('Unmatched locale path:', path);
      continue;
    }
    const [, locale, namespace] = match;
    messages[locale] = { ...messages[locale], [namespace]: localeModule.default };
  }

  return messages;
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});

export default i18n;
